import { render, staticRenderFns } from "./lzDicSelect.vue?vue&type=template&id=40033a86&"
import script from "./lzDicSelect.vue?vue&type=script&lang=js&"
export * from "./lzDicSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports